import type { HydratedDocument } from 'mongoose';
import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';
import type { UserDocument } from './user';

const UserFeedbackSystemInfoSchema = z.object({
  url: z.string().default(''),
  browser: z.string().default(''),
  os: z.string().default(''),
  engine: z.string().optional(),
  device: z.string().optional(),
  userAgent: z.string().optional(),
  timestamp: DateSchema.default(() => new Date()),
});

export const UserFeedbackSchema = z.object({
  id: ObjectIdSchema,
  content: z.string(),
  source: z.string(),
  hasBeenRead: z.boolean().default(false),
  creatorId: ObjectIdSchema,
  updaterId: ObjectIdSchema,
  createdAt: DateSchema,
  updatedAt: DateSchema,
  systemInfo: UserFeedbackSystemInfoSchema.optional(),
});

export type UserFeedback = z.infer<typeof UserFeedbackSchema>;

export interface UserFeedbackDocumentMethods {
  canEdit(user: UserDocument | Express.User): Promise<boolean>;
  canRead(user: UserDocument | Express.User): Promise<boolean>;
}

export type UserFeedbackDocument = HydratedDocument<UserFeedback, UserFeedbackDocumentMethods>;

export const UserFeedbackPrototypeSchema = UserFeedbackSchema.pick({
  content: true,
  source: true,
  systemInfo: true,
});

export type UserFeedbackPrototype = z.infer<typeof UserFeedbackPrototypeSchema>;
